module.exports = __webpack_public_path__ + "static/media/ad.f593e6f7.png";